<template lang="pug">
div(
    @click='showAlertas()',
    :class='[ativo ? "ativo" : false, isHorizontal ? "grupo-alerta-horizontal" : "grupo-alerta"]'
)
    .row.icon-row
        .col-2.center
            i(:class='iconClass')
        .col-8.info.justify-content-center.align-self-center(
            v-if='!isHorizontal'
        )
            .row.title
                .col-12
                    h3 {{ quantidade }}
            .row.subtitle
                .col-12
                    h5 {{ titulo }}

        .col-10.justify-content-between.align-items-center.d-flex.horizontal(
            v-else
        )
            span {{ titulo }}
                br(v-if='titulo === "Alertas socioambientais"')
                span(v-if='titulo === "Alertas socioambientais"') {{ `${totalAlertas.total24Horas} novas restrições (últimas 24h)` }}

            h5(v-if='titulo === "Alertas socioambientais"') {{ totalAlertas.total }}
            h5(v-else) {{ quantidade }}

        .col-2.center(v-if='!isHorizontal')
            i.colapse(
                v-if='!ativo',
                :class='{ "mdi-chevron-right mdi": !ativo }'
            )
            i.colapse(v-if='ativo', :class='{ "mdi-close mdi": ativo }')
</template>

<script>
import dateUtil from '@/utils/date';
import AlertaService from '@/services/AlertaService.js';

export default {
    name: 'GrupoAlerta',
    props: {
        iconClass: {
            type: String,
            required: true
        },
        quantidade: {
            type: Number,
            required: true
        },
        titulo: {
            type: String,
            required: true
        },
        alertas: {
            type: Array
        },
        isHorizontal: {
            type: Boolean
        }
    },
    data() {
        return {
            ativo: false,
            totalAlertas: 0,
            ultimasVinteQuatroHoras: 0
        };
    },
    created() {
        if (this.titulo === 'Alertas socioambientais') this.getTotalAlerta();
    },
    computed: {
        ultimoAlerta() {
            return dateUtil.dateDiff(
                new Date(),
                new Date(this.alertas[0].dataCadastro)
            );
        }
    },
    methods: {
        showAlertas() {
            this.$emit('click');
            this.ativo = !this.ativo;
        },
        getTotalAlerta() {
            if (this.$route.params.idAreaMonitorada) {
                AlertaService.findTotalAlertas(
                    this.$route.params.idAreaMonitorada
                )
                    .then(({ data }) => {
                        this.totalAlertas = data;
                    })
                    .catch(erro => {
                        this.$notify.error({
                            message: `Ocorreu um erro ao buscar o total - ${erro}`
                        });
                    });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.grupo-alerta {
    padding: 0 8%;
    @include border-radius($alert-border-radius);
    border: 1px solid var(--default-border-color);
    background-color: var(--white);
    width: 100%;
    cursor: pointer;

    .row {
        overflow: hidden;
    }

    .icon-row {
        height: 100%;
        position: relative;
    }

    .mdi-close {
        color: var(--primary-font-color) !important;
    }

    .ativo {
        padding: 20px !important;
        background-color: var(--selected-background-color) !important;
    }

    .grupo-alerta:hover {
        background: var(--default-background-color);
    }

    .info {
        display: inline-block;
        vertical-align: middle;
    }

    h3 {
        color: var(--primary-font-color);
        text-align: left;
        margin-bottom: 0;
        font-weight: map-get($font-weight, medium) !important;
    }

    h5 {
        color: var(--secondary-font-color);
        text-align: left;
    }

    .title {
        align-items: flex-end;
    }

    .subtitle {
        align-items: center;
    }

    .ultimoAlerta {
        font-style: italic;
        color: var(--secondary-font-color);
    }

    i {
        @include icon-size(x-large);
        // color: var(--primary);
        color: var(--secondary);
    }

    .center {
        padding: 0 4% !important;
    }

    .colapse {
        color: var(--disabled-font-color);
        @include icon-size(large);
    }
}

.grupo-alerta-horizontal {
    padding: 0 2rem;
    @include border-radius($alert-border-radius);
    border-radius: 4px;
    background-color: var(--white);
    width: 24%;
    height: 90px !important;
    cursor: pointer;

    .row {
        overflow: hidden;
    }

    .icon-row {
        height: 100%;
        position: relative;
    }

    .mdi-close {
        color: var(--primary-font-color) !important;
    }

    .ativo {
        padding: 20px !important;
        background-color: var(--selected-background-color) !important;
    }

    .grupo-alerta:hover {
        background: var(--default-background-color);
    }

    .info {
        display: inline-block;
        vertical-align: middle;
    }

    h3 {
        color: var(--primary-font-color);
        text-align: left;
        margin-bottom: 0;
        font-weight: map-get($font-weight, medium) !important;
    }

    h5 {
        color: var(--secondary-font-color);
        text-align: left;
    }

    .title {
        align-items: flex-end;
    }

    .ultimoAlerta {
        font-style: italic;
        color: var(--secondary-font-color);
    }

    i {
        @include icon-size(x-large);
        color: var(--secondary);
    }

    .center {
        padding: 0 4% !important;
    }

    .colapse {
        color: var(--disabled-font-color);
        @include icon-size(large);
    }
}

.subtitle {
    display: flex;
    align-items: center !important;
    justify-content: space-between;
    gap: 20px;
}
</style>
